import React from "react";
import Input from "../../../../Components/Common/Input";

const SubChapterForm = ({ onChange, handleSubmit, errors, formData }) => {
  return (
    <>
      <form onSubmit={handleSubmit} className="flex flex-col gap-2">
        <Input
          label="Title"
          type="text"
          name="title"
          value={formData.title}
          onChange={onChange}
          placeholder="Enter sub topic title"
          error={errors.title}
          required
        />
        <Input
          label="Description"
          type="text"
          name="description"
          value={formData.description}
          onChange={onChange}
          placeholder="Enter description"
          error={errors.description}
        />
      </form>
    </>
  );
};

export default SubChapterForm;
